import { getTypeFileAPI } from '../services/education'

export const fnGetEducationFile = async ({
  orgId,
  code,
  educationId,
  docTypeId
}) => {
  const body = {
    orgId,
    code,
    educationId,
    docTypeId
  }
  const result = await getTypeFileAPI(body)
  if (!result) return
  void window.open(result.result, '_blank')
}
